import {Image} from '@primer/react-brand'

// Assets
import ImageMona from './_assets/mona.webp'
import ImageCopilot from './_assets/copilot.webp'
import ImageDucky from './_assets/ducky.webp'

import Styles from './Mascot.module.css'

// Mascot can be set to 'Mona', 'Copilot', or 'Ducky' in Contentful
// under Section > Hero Component > Content > Generic Content > ID

type Props = {
  mascot: string
}

export function Mascot({mascot}: Props) {
  const getMascotImage = () => {
    switch (mascot) {
      case 'Mona':
        return ImageMona
      case 'Copilot':
        return ImageCopilot
      case 'Ducky':
        return ImageDucky
      default:
        return null
    }
  }

  const mascotImage = getMascotImage()

  // Don't render component if no valid mascot is found
  if (!mascotImage) {
    return null
  }

  return (
    <div className={Styles.Mascot}>
      <Image className={Styles.Image} src={mascotImage} width={230} height={230} alt="" loading="lazy" />
    </div>
  )
}

try{ Mascot.displayName ||= 'Mascot' } catch {}